import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../../hooks/useMetaPixel';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  text = 'QUIERO MI GUÍA Y RECLAMAR MI DINERO AHORA',
  onClick,
  className = ''
}: CTAButtonProps) {
  return <button onClick={e => {
    if (onClick) {
      onClick();
    } else {
      trackAddToCart();
      window.open('https://everythingfouryou.com/cart/48059162099937:1', '_blank');
    }
  }} className={`
        group relative w-full md:w-auto inline-flex items-center justify-center 
        px-8 py-5 text-lg md:text-xl font-bold text-navy-dark bg-gold-primary 
        rounded-lg overflow-hidden transition-all duration-300 
        hover:bg-gold-light hover:scale-105 hover:shadow-[0_0_30px_rgba(212,175,55,0.6)]
        animate-pulse-gold
        ${className}
      `} data-id="element-9">
      <span className="relative z-10 flex items-center gap-2 text-center leading-tight" data-id="element-10">
        {text}
        <ArrowRightIcon className="w-6 h-6 transition-transform group-hover:translate-x-1" data-id="element-11" />
      </span>
      <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-12" />
    </button>;
}